import { Box, Button, Text, Input, Select, Tabs, TabList, Tab, TabPanels, TabPanel, FormControl, useToast } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setHeaderText } from "../../redux/actions/actions";
import { loadSchedule,addExamSchedule, getClasses, getDegrees, getExamSchedules, getSpecifications, loadSessionTimings, loadSubjects, updateExamSchedule } from '../../redux/api_calls/apiCalls'
import "flatpickr/dist/themes/material_green.css";
import Flatpickr from "react-flatpickr";
import ScheduleRow from "./ScheduleRow";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";
import { deleteExamSchedule } from './../../redux/api_calls/apiCalls';

export default function ExamSchedule({ degreeState, specificationState, classesData,examHandlerValues,changeExamScheduleHandler,subjectsData,saveExamSchedule }) {
  return (
<Box  bg='white' borderRadius='20px' boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)' py='1.5rem'
                    pl='1rem' mt='1rem' pr='1rem' >
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif', marginTop: '32px' }}
                                
                            >
                                <Box width='33%'>
                                    {/* <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        Class
                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.degree_id}
                                        onChange={(e) => changeExamScheduleHandler("degree_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Degree</option>
                                        {
                                            degreeState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                                <Box width='33%'>
                                    
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.specialization_id}
                                        onChange={(e) => changeExamScheduleHandler("specialization_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Specialization</option>
                                        {
                                            specificationState.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                <Box width='33%'>
                                    {/* <Text
                        fontSize='16px'
                        fontWeight='700'
                        color='#999999'
                        mb='1rem'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                    >
                        No. of Days (per week)
                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.year_id}
                                        onChange={(e) => changeExamScheduleHandler("year_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Year</option>
                                        {
                                            classesData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>

                            </Box>
                            <Box
                                width={['100%']}
                                justifyContent='space-between'
                                alignItems='center'
                                d='flex'
                                mb='2rem'
                                fontWeight='900'
                                style={{ fontFamily: 'Mulish, sans-serif' }}
                            >
                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        Class
                                    </Text> */}
                                    <Flatpickr
                                        value={examHandlerValues.date}
                                        options={
                                            { dateFormat: 'd-m-Y',
                                             minDate: "today",
                                             disable: [new Date()],}
                                        }
                                        placeholder='Date'
                                        onChange={(date, dateStr) => changeExamScheduleHandler("date", dateStr)}
                                        style={{
                                            padding: '1rem',
                                            color: '#666666',
                                            width: '100%',
                                            height: '40px',
                                            backgroundColor: 'transparent',
                                            borderRadius: '13px',
                                            border: '1px solid rgba(0, 0, 0, 0.1)'
                                        }}

                                    />
                                </Box>

                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        No. of Days (per week)
                                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.subject_id}
                                        onChange={(e) => changeExamScheduleHandler("subject_id", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Subject</option>
                                        {
                                            subjectsData.map((className, idx) => <option value={className.id} key={idx}>{className.name}</option>)
                                        }
                                    </Select>
                                </Box>
                                <Box width='20%'>
                                    {/* <Text
                                        fontSize='16px'
                                        fontWeight='700'
                                        color='#999999'
                                        mb='1rem'
                                        style={{ fontFamily: 'Mulish, sans-serif' }}
                                    >
                                        No. of Sessions (per day)
                                    </Text> */}
                                    <Select
                                        id='type'
                                        width={["100%", "100%", "90%", "85%"]}
                                        border='1px solid rgba(0, 0, 0, 0.1)'
                                        borderRadius="13px"
                                        height='40px'

                                        value={examHandlerValues.time_noon}
                                        onChange={(e) => changeExamScheduleHandler("time_noon", e.target.value)}
                                        fontSize='18px'
                                    >
                                        <option value='' key='-1'>Select Noon Time</option>
                                        <option value="After Noon" key="1">Afternoon</option>
                                        <option value="Fore Noon" key="2">Forenoon</option>
                                    </Select>
                                </Box>

                                <Box width='12%'>
                                    <Flatpickr
                                        value={examHandlerValues.startTime}
                                        options={
                                            {
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: "H:i",
                                                time_24hr: true,
                                                 minDate: "today"
                                            }
                                        }
                                        placeholder='Start Time'
                                        onChange={(date, dateStr) => {
                                            changeExamScheduleHandler("startTime", dateStr)
                                        }}
                                        style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                    />

                                </Box>
                                <Box width='12%'>
                                    <Flatpickr
                                        value={examHandlerValues.endTime}
                                        options={
                                            {
                                                enableTime: true,
                                                noCalendar: true,
                                                dateFormat: "H:i",
                                                time_24hr: true,
                                                minDate: "today"
                                            }
                                        }
                                        placeholder='End Time'
                                        onChange={(date, dateStr) => {
                                            changeExamScheduleHandler("endTime", dateStr)
                                        }}
                                        style={{ padding: '1rem', color: '#666666', width: '90%', height: '40px', backgroundColor: '#F8F8F8', borderRadius: '13px', border: '1px solid rgba(0, 0, 0, 0.1)' }}
                                    />

                                </Box>


                                <Box height='100%' d='flex' justifyContent='center' alignItems='flex-end'>
                                    <Button
                                        fontSize='16px'
                                        fontWeight='700'
                                        style={{ fontFamily: 'Mulish, sans-serif', backgroundColor: '#00b894' }}
                                        colorScheme='messenger'
                                        onClick={saveExamSchedule}
                                    >
                                        Save
                                    </Button>
                                </Box>
                            </Box>
                            </Box>
                        );
}